import i18n from '@/common/i18n';
export function CrumbLiveList(key) {
  return {
    liveList: [
      {
        title: i18n.t('lang.k_002001'),
        path: '/live',
        isClick: false,
        redirect: 'noRedirect'
      },
      {
        title: i18n.t('lang.k_002002'),
        path: '/live/list',
        isClick: true
      }
    ],
    specialList: [
      {
        title: i18n.t('lang.k_002003'),
        path: '/special',
        isClick: false,
        redirect: 'noRedirect'
      },
      {
        title: i18n.t('lang.k_002004'),
        path: '/special/list',
        isClick: true
      }
    ],
    // 控制台融合————cms部分的面包屑，具体的路由再cms项目中
    cms: [
      {
        title: i18n.t('lang.k_002005'),
        path: '/cms',
        isClick: false,
        redirect: 'noRedirect'
      }
    ],
    interactive: [
      {
        title: i18n.t('lang.k_002006'),
        path: '/interactive',
        isClick: false,
        redirect: 'noRedirect'
      }
    ],
    AI: [
      {
        title: i18n.t('lang.k_002007'),
        path: '/AI',
        isClick: false,
        redirect: 'noRedirect'
      }
    ],
    material: [
      {
        title: i18n.t('lang.k_002008'),
        path: '/material',
        isClick: false,
        redirect: 'noRedirect'
      }
    ],
    data: [
      {
        title: i18n.t('lang.k_002009'),
        path: '/data',
        isClick: false,
        redirect: 'noRedirect'
      }
    ],
    setting: [
      {
        title: i18n.t('lang.k_002010'),
        path: '/setting',
        isClick: false,
        redirect: 'noRedirect'
      }
    ],
    finance: [
      {
        title: i18n.t('lang.k_002011'),
        path: '/plan',
        isClick: false,
        redirect: 'noRedirect'
      }
    ],
    account: [
      {
        title: i18n.t('lang.k_002012'),
        path: '/acc',
        isClick: false,
        redirect: 'noRedirect'
      }
    ]
  }[key];
}
export function CrumbSet(metaName, that) {
  console.log('当前路由：' + metaName);
  if (metaName === 'sysHome') {
    // 首页
    return [];
  } else if (metaName === 'liveList') {
    // 直播列表
    return CrumbLiveList('liveList');
  } else if (metaName === 'liveCreate') {
    // 创建直播
    return Number(that.$route.query.type) === 3
      ? [
          {
            title: i18n.t('lang.k_002001'),
            path: '/live',
            isClick: false,
            redirect: 'noRedirect'
          },
          {
            title: i18n.t('lang.k_002002'),
            path: '/live/list',
            isClick: true
          },
          {
            title: i18n.t('lang.k_002014'),
            path: '/live/edit',
            query: that.$route.query,
            isClick: false,
            redirect: 'noRedirect'
          }
        ]
      : [
          {
            title: i18n.t('lang.k_002001'),
            path: '/live',
            isClick: false,
            redirect: 'noRedirect'
          },
          {
            title: i18n.t('lang.k_002015'),
            path: '/live/edit',
            isClick: false,
            redirect: 'noRedirect'
          }
        ];
  } else if (metaName === 'vodCreate') {
    // 创建点播
    return Number(that.$route.query.type) === 3
      ? [
          {
            title: i18n.t('lang.k_002001'),
            path: '/live',
            isClick: false,
            redirect: 'noRedirect'
          },
          {
            title: i18n.t('lang.k_002002'),
            path: '/live/list',
            isClick: true
          },
          {
            title: i18n.t('lang.k_002016'),
            path: '/live/vodEdit',
            query: that.$route.query,
            isClick: false,
            redirect: 'noRedirect'
          }
        ]
      : [
          {
            title: i18n.t('lang.k_002001'),
            path: '/live',
            isClick: false,
            redirect: 'noRedirect'
          },
          {
            title: i18n.t('lang.k_002017'),
            path: '/live/vodEdit',
            isClick: false,
            redirect: 'noRedirect'
          }
        ];
  } else if (metaName === 'liveTimeCreate') {
    // 创建定时直播
    return [
      {
        title: i18n.t('lang.k_002001'),
        path: '/live',
        isClick: false,
        redirect: 'noRedirect'
      },
      {
        title: `${that.$route.query?.id ? i18n.t('lang.k_002018') : i18n.t('lang.k_002019')}`,
        path: '/live/timeEdit',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'liveDetail') {
    // 直播详情
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'liveEdit') {
    // 编辑直播
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002021'),
        path: `/live/edit/${that.$route.params.id}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'vodEdit') {
    // 编辑点播
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        query: that.$route.query,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002021'),
        path: `/live/vodEdit/${that.$route.params.id}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'liveTimeEdit') {
    // 编辑定时直播
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        query: that.$route.query,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002021'),
        path: `/live/timeEdit/${that.$route.params.id}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'chooseWay') {
    // 选择发起方式
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002022'),
        path: `/live/chooseWay/${that.$route.params.str}/1?type=ctrl`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'planFunction') {
    // 功能配置
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002023'),
        path: `/live/planFunction/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'viewerRules') {
    // 观看限制
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002024'),
        path: `/live/viewerRules/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'compliance') {
    // 观看限制
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002025'),
        path: `/live/compliance/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'roleInvitation') {
    // 角色权限
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002026'),
        path: `/live/roleInvitation/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'warm') {
    // 暖场视频
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002027'),
        path: `/live/warm/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'virtual') {
    // 虚拟人数
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002028'),
        path: `/live/virtual/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'signup') {
    // 报名表单
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002029'),
        path: `/live/signup/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'embedCard') {
    // 嵌入方式
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002030'),
        path: `/live/embedCard/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'langCard') {
    // 多语言链接
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002031'),
        path: `/live/langCard/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'msgNotification') {
    // 开播提醒
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002032'),
        path: `/live/msgNotification/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName == 'pushStream') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002132'),
        path: `/live/pushStream/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'livingSetting') {
    // 直播间设置
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002033'),
        path: `/live/livingSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'customTab') {
    // 自定义菜单
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002034'),
        path: `/live/customTab/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'customTab') {
    // 自定义菜单
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002034'),
        path: `/live/customTab/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'playerSet') {
    // 播放器设置
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002035'),
        path: `/live/playerSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'safeScreenSet') {
    // 防录屏设置
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002036'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002037'),
        path: `/live/safeScreenSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'invCard') {
    // 邀约海报
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002038'),
        path: `/live/invCard/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'channel') {
    // 推广渠道
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002039'),
        path: `/live/channel/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'advertCard' && that.$route.params.str) {
    // 广告
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002040'),
        path: `/live/advertCard/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'officialCard') {
    // 公众号展示
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002041'),
        path: `/live/officialCard/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'officeSet') {
    // 公众号展示
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002041'),
        path: `/live/officeSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'posterSet') {
    // 开屏海报展示
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002042'),
        path: `/live/posterCard/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'shareSet') {
    // 开屏海报展示
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002043'),
        path: `/live/shareSetting/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'word') {
    // 文档
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002044'),
        path: `/live/word/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'videoSet') {
    // 插播文件
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002045'),
        path: `/live/videoSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'signInSet') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002131'),
        path: `/live/signInSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'prizeSet') {
    // 抽奖
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002046'),
        path: `/live/prizeSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'prizeList') {
    // 抽奖
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002046'),
        path: `/live/prizeList/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'prizeCreat') {
    // 抽奖
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002046'),
        path: `/live/prizeList/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: `${
          that.$route.query?.lotteryId ? i18n.t('lang.k_002047') : i18n.t('lang.k_002048')
        }`,
        path: `/live/prizeSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'winnerList') {
    // 中奖名单
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002046'),
        path: `/live/prizeList/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002049'),
        path: `/live/winnerList/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'question') {
    // 问卷
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002050'),
        path: `/live/question/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'addQuestion') {
    // 创建问卷
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.webinarId}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002050'),
        path: `/live/question/${that.$route.query.webinarId}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002051'),
        path: `/live/addQuestion`,
        query: that.$route.query,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'exam') {
    // 快问快答
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002052'),
        path: `/live/exam/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'pushCard') {
    // 推屏卡片
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002053'),
        path: `/live/pushCard/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'addPushCard') {
    // 创建推屏卡片
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.webinarId}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002053'),
        path: `/live/pushCard/${that.$route.query.webinarId}`,
        query: {
          roomId: that.$route.query.roomId,
          tab: 1
        },
        isClick: true
      },
      {
        title: that.$route.query.cardId ? i18n.t('lang.k_002054') : i18n.t('lang.k_002055'),
        path: `/live/addPushCard`,
        query: that.$route.query,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'clickPushCard') {
    // 创建推屏卡片
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.webinarId}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002053'),
        path: `/live/pushCard/${that.$route.query.webinarId}`,
        query: {
          roomId: that.$route.query.roomId,
          tab: 1
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002056'),
        path: `/live/clickPushCard`,
        query: that.$route.query,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'addExam') {
    // 创建快问快答
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.webinarId}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002052'),
        path: `/live/exam/${that.$route.query.webinarId}`,
        query: {
          roomId: that.$route.query.roomId,
          tab: 1
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002055'),
        path: `/live/addExam`,
        query: that.$route.query,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'productSet') {
    // 商品
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002057'),
        path: `/live/productSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'couponData') {
    // 商品优惠券
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002057'),
        path: `/live/productSet/${that.$route.params.str}`,
        query: {
          tab: 1
        }
      },
      {
        title: i18n.t('lang.k_002058'),
        path: `/live/couponData/${that.$route.params.str}`,
        isClick: false,
        query: {
          webinarId: that.$route.query.webinarId
        },
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'gift') {
    // 礼物
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002059'),
        path: `/live/gift/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'InteractReward') {
    // 互动有礼
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002060'),
        path: `/live/InteractReward/${that.$route.params.str}`,
        isClick: false,
        query: {
          roomId: that.$route.query.roomId
        },
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'InteractiveRewardSetting') {
    // 互动有礼创建、编辑、复制
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002060'),
        path: `/live/InteractReward/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: `${
          that.$route.query?.copy_id
            ? i18n.t('lang.k_002061')
            : that.$route.query?.id
            ? i18n.t('lang.k_002054')
            : i18n.t('lang.k_002055')
        }`,
        path: `/live/InteractiveRewardSetting/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId,
          copy_id: that.$route.query.copy_id,
          id: that.$route.query.id
        },
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'InteractiveRewardUserList') {
    // 互动有礼领奖用户列表
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002060'),
        path: `/live/InteractReward/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002062'),
        path: `/live/InteractiveRewardUserList/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId,
          op: that.$route.query.op
        },
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'WatchReward') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002063'),
        path: `/live/WatchReward/${that.$route.params.str}`,
        isClick: false,
        query: {
          roomId: that.$route.query.roomId
        },
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'WatchRewardWinnerList') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002063'),
        path: `/live/WatchReward/${that.$route.params.str}`,
        isClick: true,
        query: {
          roomId: that.$route.query.roomId
        }
      },
      {
        title: i18n.t('lang.k_002049'),
        isClick: false,
        path: `/live/WatchRewardWinnerList/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        },
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'WatchRewardSetting') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002063'),
        path: `/live/WatchReward/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        }
      },
      {
        title: `${that.$route.query?.wrId ? i18n.t('lang.k_002054') : i18n.t('lang.k_002055')}`,
        path: `/live/WatchRewardSetting/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'CashPacketList') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002064'),
        path: `/live/CashPacket/${that.$route.params.id}`
      }
    ];
  } else if (metaName === 'CashPacketEdit') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002064'),
        path: `/live/CashPacket/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: `${that.$route.query?.id ? i18n.t('lang.k_002054') : i18n.t('lang.k_002055')}`,
        path: `/live/CashPacket/edit/${that.$route.params.id}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'receiptDetails') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002064'),
        path: `/live/CashPacket/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: `${i18n.t('lang.k_002065')}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'MallRewardsList') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002066'),
        path: `/live/MallRewards/${that.$route.params.id}`
      }
    ];
  } else if (metaName === 'MallRewardsEdit') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002066'),
        path: `/live/MallRewards/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: `${that.$route.query?.id ? i18n.t('lang.k_002054') : i18n.t('lang.k_002055')}`,
        path: `/live/MallRewards/edit/${that.$route.params.id}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'mallReceiptDetails') {
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002066'),
        path: `/live/MallRewards/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: `${i18n.t('lang.k_002065')}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'playback') {
    // 回放管理
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002068'),
        path: `/live/playback/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'playbackGroupList') {
    // 回放管理- 小组视频
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002069'),
        path: `/live/playback/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002070'),
        path: `/live/playback/${that.$route.params.str}/group`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'chapter') {
    // 章节打点
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002069'),
        path: `/live/playback/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002071'),
        path: `/live/chapter/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'vodreset') {
    // 回放重制
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002069'),
        path: `/live/playback/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002072'),
        path: `/live/vodreset/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'recordplayback') {
    // 点播管理
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002068'),
        path: `/live/recordplayback/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'publishplayback') {
    // 定时直播管理
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002068'),
        path: `/live/publishplayback/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'recordchapter') {
    // 章节打点
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002075'),
        path: `/live/recordplayback/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002071'),
        path: `/live/recordchapter/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'reportsData') {
    // 数据报告
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002076'),
        path: `/live/reportsData/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'interactionData') {
    // 互动统计
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002077'),
        path: `/live/interactionData/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'userData') {
    // 用户统计
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002078'),
        path: `/live/userData/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'interactionDetail') {
    // 邀请人数、聊天、问答、签到、问卷、抽奖、发群红包、
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002077'),
        path: `/live/interactionData/${that.$route.query.id}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: `${that.$route.query.title}`,
        mkey: `${that.$route.query.mkey}`,
        path: `/live/interactionDetail`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'invitedDataInfo') {
    console.log(that.$route, 'invitedDataInfo');
    // 邀请人数明细、
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002077'),
        path: `/live/interactionData/${that.$route.query.id}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: `${i18n.t('lang.k_002079')}`,
        path: `/live/interactionDetail`,
        query: that.$route.query,
        isClick: true
      },
      {
        title: `${that.$route.meta.title}`,
        mkey: `${that.$route.query.mkey}`,
        path: `/live/interactionDetail/invitedDataInfo`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'lookSingleQuestion') {
    // 邀请人数、聊天、问答、签到、问卷、抽奖、发群红包、
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002077'),
        path: `/live/interactionData/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: `${i18n.t('lang.k_002050')}`,
        path: `/live/interactionDetail`,
        query: {
          roomId: that.$route.query.roomId,
          id: that.$route.params.str,
          title: i18n.t('lang.k_002050'),
          mkey: 'question'
        },
        isClick: true
      },
      {
        title: `${i18n.t('lang.k_002080')}`,
        path: `/live/lookSingleQuestion/${that.$route.params.str}`,
        query: that.$route.query,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'lookSingleExam') {
    // 邀请人数、聊天、问答、签到、问卷、快问快答、抽奖、发群红包
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.str}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002077'),
        path: `/live/interactionData/${that.$route.params.str}`,
        query: {
          roomId: that.$route.query.roomId
        },
        isClick: true
      },
      {
        title: `${i18n.t('lang.k_002052')}`,
        path: `/live/interactionDetail`,
        query: {
          roomId: that.$route.query.roomId,
          id: that.$route.params.str,
          title: i18n.t('lang.k_002052')
        },
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'specialList') {
    /** 专题 **/
    // 专题列表
    return CrumbLiveList('specialList');
  } else if (metaName === 'subjectEdit') {
    // 创建专题、编辑专题
    return that.$route.params.id
      ? [
          {
            title: i18n.t('lang.k_002003'),
            path: '/special',
            isClick: false,
            redirect: 'noRedirect'
          },
          {
            title: i18n.t('lang.k_002004'),
            path: '/special/list',
            isClick: true
          },
          {
            title: i18n.t('lang.k_002081'),
            path: `/special/details/${that.$route.params.id}`,
            isClick: true
          },
          {
            title: `${i18n.t('lang.k_002054')}${
              that.$route.query.type == 2 ? i18n.t('lang.k_002083') : i18n.t('lang.k_002084')
            }${i18n.t('lang.k_002082')}`,
            path: `/special/edit/${that.$route.params.id}`,
            isClick: true
          }
        ]
      : [
          {
            title: i18n.t('lang.k_002003'),
            path: '/special',
            isClick: false,
            redirect: 'noRedirect'
          },
          {
            title: `${i18n.t('lang.k_002055')}${
              that.$route.query.type == 2 ? i18n.t('lang.k_002083') : i18n.t('lang.k_002084')
            }${i18n.t('lang.k_002082')}`,
            path: '/special/edit',
            isClick: true
          }
        ];
  } else if (metaName === 'subjectViewer') {
    return [
      {
        title: i18n.t('lang.k_002003'),
        path: '/special',
        isClick: false,
        redirect: 'noRedirect'
      },
      {
        title: i18n.t('lang.k_002004'),
        path: '/special/list',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002081'),
        path: `/special/details/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002024'),
        path: '/special/viewer',
        isClick: true
      }
    ];
  } else if (metaName === 'subjectDetails') {
    return [
      {
        title: i18n.t('lang.k_002003'),
        path: '/special',
        isClick: false,
        redirect: 'noRedirect'
      },
      {
        title: i18n.t('lang.k_002004'),
        path: '/special/list',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002081'),
        path: `/special/details/${that.$route.params.id}`,
        isClick: true
      }
    ];
  } else if (metaName === 'subjectData') {
    return [
      {
        title: i18n.t('lang.k_002003'),
        path: '/special',
        isClick: false,
        redirect: 'noRedirect'
      },
      {
        title: i18n.t('lang.k_002004'),
        path: '/special/list',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002081'),
        path: `/special/details/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002085'),
        path: '/special/data',
        isClick: true
      }
    ];
  } else if (metaName === 'cmsList') {
    /** 站点管理 **/
    // 站点列表
    return [
      ...CrumbLiveList('cms'),
      {
        title: i18n.t('lang.k_002086'),
        path: '/cms/index',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'cmsCreate') {
    /** 站点管理 **/
    // 创建站点
    return [
      ...CrumbLiveList('cms'),
      {
        title: i18n.t('lang.k_002087'),
        path: '/cms/create',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'wordMgr') {
    /** 资料管理 **/
    // 资料-文档
    return [
      ...CrumbLiveList('material'),
      {
        title: i18n.t('lang.k_002044'),
        path: '/material/word',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'videoMgr') {
    // 资料-音视频
    return [
      ...CrumbLiveList('material'),
      {
        title: i18n.t('lang.k_002088'),
        path: '/material/video',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'questionMgr') {
    /** 互动工具 **/
    // 互动工具-问卷
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002089'),
        path: '/interactive/question',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'addQuestionMgr') {
    // 互动工具-问卷-创建问卷
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002089'),
        path: '/interactive/question',
        isClick: true
      },
      {
        title: that.$route.query.questionId ? i18n.t('lang.k_002090') : i18n.t('lang.k_002091'),
        path: '/interactive/addQuestion',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'pushCardMgr') {
    // 资料-推屏卡片
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002053'),
        path: '/interactive/pushCard',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'addPushCardMgr') {
    // 资料-推屏卡片-创建
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002053'),
        path: '/interactive/pushCard',
        isClick: true
      },
      {
        title: that.$route.query.cardId ? i18n.t('lang.k_002054') : i18n.t('lang.k_002055'),
        path: '/interactive/addPushCard',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'examMgr') {
    // 资料-快问快答
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002052'),
        path: '/interactive/exam',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'addExamMgr') {
    // 资料-快问快答-创建
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002052'),
        path: '/interactive/exam',
        isClick: true
      },
      {
        title: that.$route.query.examId ? i18n.t('lang.k_002054') : i18n.t('lang.k_002055'),
        path: '/interactive/addExam',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'prizeMgr') {
    // 资料-奖品
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002092'),
        path: '/interactive/prize',
        isClick: true
      }
    ];
  } else if (metaName === 'mallAwardList') {
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002066'),
        path: '/interactive/awardList',
        isClick: true
      }
    ];
  } else if (metaName === 'viewerMgr') {
    // 资料-观众
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002093'),
        path: '/setting/viewer',
        isClick: true
      }
    ];
  } else if (metaName === 'channelSetting') {
    // 运营设置  - 渠道管理
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002094'),
        path: '/setting/channel',
        isClick: true
      }
    ];
  } else if (metaName === 'commonParams') {
    // 运营设置  - 通用字段
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002095'),
        path: '/setting/commonParams',
        isClick: true
      }
    ];
  } else if (metaName === 'officialAccAuth') {
    // 运营设置  - 公众号授权
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002096'),
        path: '/setting/officialAccAuth',
        isClick: true
      }
    ];
  } else if (metaName === 'webinarBusinessField') {
    // 运营设置  - 直播业务字段
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002097'),
        path: '/setting/webinarBusinessField',
        isClick: true
      }
    ];
  } else if (metaName === 'setVipTag') {
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002098'),
        path: '/setting/setVipTag',
        isClick: true
      }
    ];
  } else if (metaName === 'advertCard') {
    // 互动工具-广告
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002040'),
        path: '/interactive/advertCard',
        isClick: true
      }
    ];
  } else if (metaName === 'products') {
    // 互动工具-商品
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002057'),
        path: '/interactive/products',
        isClick: true
      }
    ];
  } else if (metaName === 'createproducts') {
    // 资料-商品-创建
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002057'),
        path: '/interactive/products',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002099'),
        path: '/interactive/addProduct',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'createCoupon') {
    // 资料-商品-创建
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002057'),
        path: '/interactive/products',
        query: {
          tab: '1'
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002100'),
        path: '/interactive/addCoupon',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'editproducts') {
    // 资料-商品-编辑
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002057'),
        path: '/interactive/products',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002101'),
        path: '/interactive/editProduct',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'editCoupon') {
    // 资料-商品-编辑
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002057'),
        path: '/interactive/products',
        query: {
          tab: '1'
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002102'),
        path: '/interactive/editCoupon',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'copyCoupon') {
    // 资料-商品-编辑
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002057'),
        path: '/interactive/products',
        query: {
          tab: '1'
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002103'),
        path: '/interactive/copyCoupon',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'viewCoupon') {
    // 资料-商品-编辑
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002057'),
        path: '/interactive/products',
        query: {
          tab: '1'
        },
        isClick: true
      },
      {
        title: i18n.t('lang.k_002058'),
        path: '/interactive/viewCoupon',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'giftMgr') {
    // 互动工具-礼物
    return [
      ...CrumbLiveList('interactive'),
      {
        title: i18n.t('lang.k_002059'),
        path: '/interactive/gift',
        isClick: true
      }
    ];
  } else if (metaName === 'dataInfo') {
    /** 数据总览 **/
    // 数据中心-数据总览
    return [
      ...CrumbLiveList('data'),
      {
        title: i18n.t('lang.k_002104'),
        path: '/data/info',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'dataLive') {
    // 数据中心-活动数据
    return [
      ...CrumbLiveList('data'),
      {
        title: i18n.t('lang.k_002009'),
        path: '/data/live',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'settingInfo') {
    /** 运营设置 **/
    //运营设置
    return [...CrumbLiveList('setting')];
  } else if (metaName === 'chatMgr') {
    //运营设置-聊天设置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002105'),
        path: '/setting/chat',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'safeScreen') {
    //运营设置-防录屏设置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002037'),
        path: '/setting/safeScreen',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'devMgr') {
    //运营设置-开发设置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002106'),
        path: '/setting/dev',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'devCallback') {
    //运营设置-开发设置-回调设置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002106'),
        path: '/setting/dev',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002107'),
        path: '/dev/callback',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'devModify') {
    //运营设置-开发设置-应用详情
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002106'),
        path: '/setting/dev',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002108'),
        path: `/dev/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'logoMgr') {
    //运营设置-控制台标识
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002109'),
        path: '/setting/logo',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'functionMgr') {
    //运营设置-功能配置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002023'),
        path: '/setting/functionMgr',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'livingMgr') {
    //运营设置-直播间设置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002033'),
        path: '/setting/brand',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'protocolMgr') {
    //运营设置-观看协议
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002025'),
        path: '/setting/protocol',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'playerMgr') {
    //运营设置-播放器设置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002035'),
        path: '/setting/playerMgr',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'tagset') {
    //运营设置-标签设置
    return [
      ...CrumbLiveList('setting'),
      {
        title: i18n.t('lang.k_002110'),
        path: '/setting/tagset',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'financeInfo') {
    /** 账户管理-财务中心 **/
    //财务中心-财务总览
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002111'),
        path: '/plan/info',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'infoDetail') {
    //财务中心-订单明细
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002111'),
        path: '/plan/info',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002112'),
        path: '/plan/infoDetail',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'payOrder') {
    //财务中心-订单支付
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002111'),
        path: '/plan/info',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002113'),
        path: '/plan/payOrder',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'orderDetail') {
    //财务中心-版本升级
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002111'),
        path: '/plan/info',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002114'),
        path: '/plan/orderDetail',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'financeIncome') {
    //财务中心-账户收益
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002115'),
        path: '/plan/income',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'accountDetail') {
    //财务中心-提现明细
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002115'),
        path: '/plan/income',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002116'),
        path: '/plan/accountDetail',
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'incomeDetail') {
    //财务中心-收益详情
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002115'),
        path: '/plan/income',
        isClick: true
      },
      {
        title: i18n.t('lang.k_002117'),
        path: `/plan/incomeDetail/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'accountInfo') {
    /** 账户管理 **/
    //账户管理-账户信息
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002118'),
        path: `/acc/info`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'sonMgr') {
    //账户管理-子账号管理
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002119'),
        path: `/acc/son`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'allocation') {
    //账户管理-子账号管理
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002119'),
        path: `/acc/son`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002120'),
        path: `/allocation`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'dataRecord') {
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002119'),
        path: `/acc/son`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002120'),
        path: `/allocation`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002121'),
        path: `/allocation/dataRecord`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'sonDetail') {
    //账户管理-子账号详情
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002119'),
        path: `/acc/son`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002122'),
        path: `/sonDetail/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'myHome') {
    //账户管理-个人主页
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002123'),
        path: `/acc/myHome`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'homeSet') {
    //账户管理-个人主页-设置
    return [
      ...CrumbLiveList('account'),
      {
        title: i18n.t('lang.k_002123'),
        path: `/acc/myHome`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002124'),
        path: `/homeSet/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'downloadList') {
    /** 下载中心 **/
    //下载中心
    return [
      {
        title: i18n.t('lang.k_002125'),
        path: `/other/downloadList`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'feedbackList') {
    /** 用户反馈 **/
    //用户反馈
    return [
      {
        title: i18n.t('lang.k_002130'),
        path: `/other/feedbackList`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'msgList') {
    /** 消息中心 **/
    //消息中心
    return [
      {
        title: i18n.t('lang.k_002126'),
        path: `/other/msgList`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'trash') {
    //回收站
    return [
      {
        title: i18n.t('lang.k_002127'),
        path: `/other/trash`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'msgDetail') {
    //消息详情
    return [
      {
        title: i18n.t('lang.k_002126'),
        path: `/other/msgList`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002128'),
        path: `/other/msgDetail/${that.$route.params.str}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'AIChatList') {
    // AI智能  - 聊天
    return [
      ...CrumbLiveList('AI'),
      {
        title: i18n.t('lang.k_002129'),
        path: `/AI/chat/list`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'AIChatCreate') {
    // AI智能  - 聊天
    return [
      ...CrumbLiveList('AI'),
      {
        title: i18n.t('lang.k_002129'),
        path: `/AI/chat/list`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002055'),
        path: `/AI/chat/create`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'AIChatEdit') {
    // AI智能  - 聊天
    return [
      ...CrumbLiveList('AI'),
      {
        title: i18n.t('lang.k_002129'),
        path: `/AI/chat/list`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002054'),
        path: `/AI/chat/edit`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'AIChatListLive') {
    // AI智能  - 聊天
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.params.id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002129'),
        path: `/live/AI/chat/list`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'AIChatCreateLive') {
    // AI智能  - 聊天
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.webinar_id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002129'),
        path: `/live/AI/chat/list/${that.$route.query.webinar_id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002055'),
        path: `/AI/chat/create?webinar_id=${that.$route.query.webinar_id}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else if (metaName === 'AIChatEditLive') {
    // AI智能  - 聊天
    return [
      ...CrumbLiveList('liveList'),
      {
        title: i18n.t('lang.k_002020'),
        path: `/live/detail/${that.$route.query.webinar_id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002129'),
        path: `/live/AI/chat/list/${that.$route.query.webinar_id}`,
        isClick: true
      },
      {
        title: i18n.t('lang.k_002054'),
        path: `/AI/chat/edit/${that.$route.params.id}?webinar_id=${that.$route.query.webinar_id}`,
        isClick: false,
        redirect: 'noRedirect'
      }
    ];
  } else {
    return [];
  }
}
